import { registerComponent, asyncRequest, loading } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "swatch-link",
  class SwatchLink extends WYATTElement {
    constructor() {
      super();

      this.productSummary = this.closest(".product-summary");
      this.link = this.querySelector("a");

      if (!this.link) {
        return;
      }

      this.link.addEventListener("click", this.handleClick.bind(this));
    }

    handleClick(event) {
      event.preventDefault();

      loading.add(this.productSummary);

      this.getProductSummary();
    }

    // A horizontal card comes back from the view that renders the snippet with
    // the same horizontal_layout, whether its classes came from that param or
    // from product-summary.js's data-class-list.
    get view() {
      const { classList } = this.productSummary;

      if (classList.contains("product-summary--horizontal-until-medium")) {
        return "summary-horizontal-until-medium";
      }

      if (classList.contains("product-summary--horizontal")) {
        return "summary-horizontal";
      }

      return "summary";
    }

    async getProductSummary() {
      const response = await asyncRequest(
        `${this.config.url}&view=${this.view}`,
      );

      if (response) {
        this.handleSuccessfulUpdate(response);
      } else {
        window.location.href = this.config.url;
      }
    }

    handleSuccessfulUpdate(html) {
      this.productSummary.outerHTML = html;
    }
  },
);
